module.exports = __webpack_public_path__ + "media/images/favicon-16x16-2008210b35ee9edd876c1f252bc20140.png";